import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadPlacementLocationOptions } from '../store/options.actions'

export function* getVadPlacementLocationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVadPlacementLocationOptions])
    const { entity } = response
    yield put(setVadPlacementLocationOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadPlacementLocationOptions() error: ${e}`))
  }
}
export function* getVadPlacementLocationOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVadPlacementLocationOptions)
}
